import { DateUtil } from "@/utils/chart/date_class.js";
import { getInitCandleLast, getInitCandleLastBefore } from "@/api/apiChart.js";

let candleLast, candleBefore, getData;
let formatPrice = (price) => price.toFixed(4);
const kind = localStorage.getItem("ticker");

let setLegendHtml = (
  name,
  date,
  openPriceFormatted,
  highPriceFormatted,
  lowPriceFormatted,
  closePriceFormatted,
  closePriceChange,
  priceChange,
  legend
) => {
  // console.log(
  //   "openPriceFormatted",
  //   openPriceFormatted,
  //   "close",
  //   closePriceFormatted
  // );

  if (openPriceFormatted > closePriceFormatted) {
    //red
    legend.style.color = "#EE7272";
  } else if (openPriceFormatted < closePriceFormatted) {
    //green
    legend.style.color = "#5DB9CD";
  }

  legend.innerHTML = `<div class="Legend">${name}USDT<br/> <strong>${date}</strong><br/> O: ${openPriceFormatted}<br/> H: ${highPriceFormatted}<br/> L: ${lowPriceFormatted}<br/> C: ${closePriceFormatted}<br/> ${closePriceChange} (${priceChange})`;
};

let getLastBar = (series) => {
  var getCandleSeries = series.data();
  // console.log('getCandleSeries',getCandleSeries);

  if (getCandleSeries == 0 || getCandleSeries == undefined) {
    candleLast = getInitCandleLast(kind);
    candleBefore = getInitCandleLastBefore(kind);
  } else {
    candleLast = getCandleSeries[getCandleSeries.length - 1];
    candleBefore = getCandleSeries[getCandleSeries.length - 2];
  }
  return { candleLast, candleBefore };
  // const lastIndex = series.dataByIndex(Number.MAX_SAFE_INTEGER, 1);
  // return series.dataByIndex(lastIndex);
};

export let updateLegend = (param, series, legend, kind) => {
  window.onerror = function (message) {
    if (typeof message === "string" && message.includes("Value is undefined")) {
      // Prevent the error from being logged in the console
      return true;
    }

    return false;
  };
  // if (param !== undefined && param.time === undefined) return;
  // var validCrosshairPoint = !(
  //   param === undefined ||
  //   param.time === undefined ||
  //   param.point.x < 0 ||
  //   param.point.y < 0
  // );
  // // console.log(validCrosshairPoint);
  // const firstEntry = validCrosshairPoint
  //   ? Array.from(param.seriesData.entries())[0]
  //   : "";
  // const [firstSeries, firstBar] = firstEntry;
  // // console.log("첫 번째 시리즈:", firstEntry);

  // // console.log("첫 번째 시리즈:", firstSeries);
  // // console.log("첫 번째 바 데이터:", firstBar);

  // var bar = validCrosshairPoint ? firstBar : getLastBar(series).candleLast;
  // // point 있으면 데이터 가져오고 없으면 초기설정된 마지막 바 가져오기
  // // console.log('param',param,'bar',bar);
  // // console.log("param", param, "bar", bar);
  // // console.log(getLastBar(series).candleLast);

  // 어느 부분에 마우스를 대면 valid가 false가 되면서 param 안에 있는 내용들이 다 undefined가 되면서 오류
  var validCrosshairPoint = !(
    param === undefined ||
    param.time === undefined ||
    param.point.x < 0 ||
    param.point.y < 0
  );
  // let beforePriceIndex = param.logical
  // console.log("valid", validCrosshairPoint, "param", param);

  var bar = validCrosshairPoint
    ? Array.from(param.seriesData.entries())[0][1]
    : getLastBar(series).candleLast;

  // console.log("bar", bar);

  // if (param && (param.point == undefined || param.time == undefined)) return;
  // console.log("bar", bar, "series", series, "param", param);
  let openPrice = bar.open;
  let highPrice = bar.high;
  let lowPrice = bar.low;
  let closePrice = bar.close;

  let openPriceFormatted = formatPrice(openPrice);
  let highPriceFormatted = formatPrice(highPrice);
  let lowPriceFormatted = formatPrice(lowPrice);
  let closePriceFormatted = formatPrice(closePrice);
  let priceChange = (
    ((closePriceFormatted - openPriceFormatted) / openPriceFormatted) *
    100
  ).toFixed(2);
  if (priceChange < 0) {
    priceChange = `${priceChange}%`;
  } else {
    priceChange = `+${priceChange}%`;
  }
  // 변동값 계산 (현재 종가 - 그전 종가 소수점 4자리까지 )
  getData = series.data();
  // console.log("getData", getData);

  let closePriceChange;
  if (validCrosshairPoint && param.logical && param.logical == 0) {
    closePriceChange = "";
  } else {
    candleBefore = validCrosshairPoint
      ? param.logical
        ? getData[param.logical - 1]
        : getLastBar(series).candleBefore
      : getLastBar(series).candleBefore;
    // console.log('logical',param.logical-1,'getData',getData,'candleBefore',candleBefore);

    closePriceChange = formatPrice(bar.close - candleBefore.close);
    // console.log(
    //   "candleBefore",
    //   candleBefore,
    //   "closePriceChange",
    //   closePriceChange
    // );
  }
  let timestampToString = DateUtil.convertTimeScale(bar.time);
  // console.log("timestampToString", timestampToString);

  setLegendHtml(
    kind,
    timestampToString,
    openPriceFormatted,
    highPriceFormatted,
    lowPriceFormatted,
    closePriceFormatted,
    closePriceChange,
    priceChange,
    legend
  );
  // console.log('x:',param.point.x, 'y:',param.point.y);
};

export let appendLegend = (container, type, legend) => {
  legend.id = `Legend`;
  container.appendChild(legend);
};
